import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const EmailSentSuccess = ({ email }) => {
    const navigate = useNavigate();
    const [seconds, setSeconds] = useState(5);

    // Auto redirect to login after 5 seconds with countdown
    // useEffect(() => {
    //     const timer = setInterval(() => {
    //         setSeconds((prev) => {
    //             if (prev <= 1) {
    //                 clearInterval(timer);
    //                 navigate('/');
    //                 return 0;
    //             }
    //             return prev - 1;
    //         });
    //     }, 10000000000);

    //     return () => clearInterval(timer);
    // }, [navigate]);

    const handleBackToLogin = () => {
        navigate('/');
    };

    return (
        <div className="email-success-fullscreen">
            {/* Green Tick */}
            <div className="tick-container">
                <svg className="green-tick" viewBox="0 0 52 52">
                    <circle className="tick-circle" cx="26" cy="26" r="25" fill="none" />
                    <path className="tick-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                </svg>
            </div>

            {/* Message */}
            <h1 className="success-heading">Check Your Email!</h1>
            <h3>If this email is registered with us, you'll receive a password reset link shortly.</h3>
            
            {/* <p className="success-message">
                We've sent a reset link to <span className="email-text">{email}</span>
            </p> */}

            {/* Login Button */}
            {/* <button onClick={handleBackToLogin} className="login-btn">
                Back to Login ({seconds}s)
            </button> */}

            <style>{`
                .email-success-fullscreen {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    width: 100vw;
                    height: 100vh;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
                    z-index: 9999;
                }

                /* Tick Animation */
                .tick-container {
                    margin-bottom: 30px;
                }

                .green-tick {
                    width: 120px;
                    height: 120px;
                    display: block;
                }

                .tick-circle {
                    stroke-dasharray: 166;
                    stroke-dashoffset: 166;
                    stroke-width: 2;
                    stroke-miterlimit: 10;
                    stroke: #4CAF50;
                    fill: none;
                    animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
                }

                .tick-check {
                    transform-origin: 50% 50%;
                    stroke-dasharray: 48;
                    stroke-dashoffset: 48;
                    stroke-width: 2;
                    stroke: #4CAF50;
                    animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
                }

                @keyframes stroke {
                    100% {
                        stroke-dashoffset: 0;
                    }
                }

                /* Text Styles */
                .success-heading {
                    color: vlack;
                    font-size: 42px;
                    font-weight: 600;
                    margin: 0 0 15px 0;
                    text-shadow: 2px 2px 4px rgba(255, 255, 255, 0.2);
                }

                .success-message {
                    color: rgba(255, 255, 255, 0.9);
                    font-size: 18px;
                    margin: 0 0 40px 0;
                    text-align: center;
                }

                .email-text {
                    background: rgba(255, 255, 255, 0.2);
                    padding: 4px 12px;
                    border-radius: 50px;
                    font-weight: 600;
                    display: inline-block;
                    margin-top: 8px;
                }

                /* Button */
                .login-btn {
                    background: white;
                    color: #667eea;
                    border: none;
                    padding: 14px 40px;
                    font-size: 18px;
                    font-weight: 600;
                    border-radius: 50px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
                }

                .login-btn:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
                }

                /* Responsive */
                @media (max-width: 480px) {
                    .green-tick {
                        width: 100px;
                        height: 100px;
                    }

                    .success-heading {
                        font-size: 32px;
                    }

                    .success-message {
                        font-size: 16px;
                        padding: 0 20px;
                    }

                    .login-btn {
                        padding: 12px 30px;
                        font-size: 16px;
                    }
                }
            `}</style>
        </div>
    );
};

export default EmailSentSuccess;